import css from 'styled-jsx/css';
import { screen, colors, fonts } from 'components/styles/variables';
import searchIcon from 'public/static/images/paid_landing/search-icon.svg';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    fontFamily: fonts.default,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.2px',
  },
  input: {
    textOverflow: 'ellipsis',
  },
});

export const styles = css`
  .mobile-text-search-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 4px 0 16px;
    box-shadow: 0px 1px 0px ${colors.G2};
    width: 100vw;
    max-height: 64px;
  }

  @media (min-width: ${screen.smMin}) {
    .mobile-text-search-container,
    .filters-mobile {
      display: none;
    }
  }

  .filters-mobile {
    box-shadow: 0px 1px 0px ${colors.G2};
  }

  .search-icon {
    height: 26px;
    width: 26px;
    background: url(${searchIcon});
    background-size: cover;
  }
`;

export default useStyles;
